import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '45px',
    marginBottom: '20px'
  },
  primaryFilter: {
    height: '69px',
    marginBottom: '10px'
  },
  secondaryFilter: {
    height: '69px',
    marginBottom: '40px'
  },
  fareItem: {
    height: '90px',
    marginBottom: '10px'
  },
  map: {
    height: '478px',
    marginBottom: '10px'
  }
};

const SkeletonInteractiveMap = (props) => {
  const [className, style] = useStyles(props);

  const { header, primaryFilter, secondaryFilter, fareItem, map } = styles;
  return (
    <Box
      className={`${className} ${SkeletonInteractiveMap.componentName} fr-skeleton`}
      style={style}
    >
      <Row gutters>
        <Col className={`${SkeletonInteractiveMap.componentName} fr-skeleton--header`}>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col
          className={`${SkeletonInteractiveMap.componentName} fr-skeleton-content`}
          xs="4"
          paddingRight="10px"
        >
          <Box
            className={`${SkeletonInteractiveMap.componentName} fr-skeleton-primary-filters fr-skeleton-element`}
            style={primaryFilter}
          />
          <Box
            className={`${SkeletonInteractiveMap.componentName} fr-skeleton-secondary-filters fr-skeleton-element`}
            style={secondaryFilter}
          />
          <Box
            className={`${SkeletonInteractiveMap.componentName} fr-skeleton-fare-item fr-skeleton-element`}
            style={fareItem}
          />
          <Box
            className={`${SkeletonInteractiveMap.componentName} fr-skeleton--item fr-skeleton-element`}
            style={fareItem}
          />
          <Box
            className={`${SkeletonInteractiveMap.componentName} fr-skeleton-fare-item fr-skeleton-element`}
            style={fareItem}
          />
        </Col>
        <Col
          className={`${SkeletonInteractiveMap.componentName} fr-skeleton-map`}
          xs="8"
          paddingLeft="10px"
        >
          <Box className="fr-skeleton-element" style={map} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonInteractiveMap.componentName = 'SkeletonInteractiveMap';

export default SkeletonInteractiveMap;
